import React, { useMemo, useState, useRef, useEffect } from 'react';

import SendInvite from '../../components/sendInvite/SendInvite';
import ValidationException from '../../exceptions/ValidationException';
import User from '../../models/User';
import useBlocRef from '../../utils/useBlocRef.hook';

export default ({ workspaceId, onUpdateAdmins }) => {
  const blocRef = useBlocRef('resendInviteBloc');
  const [validationErrors, setValidationErrors] = useState(null);
  const [admin] = useState(new User());

  const validationErrorsRef = useRef(null);

  const inviteFields = useMemo(
    () => [
      {
        label: 'Administrator Name',
        name: 'name',
        onChange: () => {
          const validations = validationErrorsRef.current;
          if (validations?.name) delete validations.name;
          setValidationErrors(validations);
        },
        placeholder: 'Administrator Name',
        required: true,
        type: 'text',
      },
      {
        label: 'Telephone',
        name: 'phoneNumber',
        onChange: () => {
          const validations = validationErrorsRef.current;
          if (validations?.phoneNumber) delete validations.phoneNumber;
          setValidationErrors(validations);
        },
        placeholder: '+27828501512',
        required: true,
        type: 'phone',
      },
      {
        label: 'Administrator Email Address',
        name: 'email',
        onChange: () => {
          const validations = validationErrorsRef.current;
          if (validations?.email) delete validations.email;
          setValidationErrors(validations);
        },
        placeholder: 'email@address.com',
        required: true,
        type: 'text',
      },
    ],
    []
  );

  const onInvite = async ({ name, phoneNumber, email }) => {
    try {
      await blocRef.current.inviteAdmin(name, phoneNumber, email, workspaceId);
      onUpdateAdmins();
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      }
    }
  };

  useEffect(() => {
    validationErrorsRef.current = validationErrors;
  }, [validationErrors]);

  return (
    <SendInvite
      fields={inviteFields}
      buttonText="Invite Administrator"
      onInvite={onInvite}
      title="Add Administrator"
      hint="Add an administrator to the selected workspace. "
      note="Note that an invitation link will be sent to the administrator email address once the workspace is created"
      user={admin}
      isSubmitting$={blocRef.current.isInvitingAdmin$}
      errors={validationErrors}
    />
  );
};
